export class ShippingVendorModel {
  Id: number = 0;
  ShippingVendorId!: number;
  AccountNum!: string;
  AddressId: string;
}
